// extracted by mini-css-extract-plugin
module.exports = {"hosts":"footer_hosts__XX7u6","partnerLogo":"footer_partnerLogo__AF7Iy","container":"footer_container__BLr_W","section":"footer_section__1R5Y4","footer":"footer_footer__2DXVJ"};